module.exports = __webpack_public_path__ + "assets/img/3-6.7cb1def5.png";